module.exports = "<div *ngFor=\"let favorite of favList | async\" class=\"favoriteItem\">\n  <div><a href=\"{{ favorite.url }}\" target=\"blank\"><h3>{{ favorite.name }}</h3></a></div>\n  <div><img class=\"pencil\" (click)=\"openModal(favorite)\" src=\"assets/pencil.png\" alt=\"Notes\"></div>\n  <div><span class=\"delete\" alt=\"Delete\" (click)=\"deleteFavorite(favorite)\">x</span></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Food-Savor/src/app/favorite-list/favorite-list.component.html
// module id = ../../../../../src/app/favorite-list/favorite-list.component.html
// module chunks = main